import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { LineChart, Shield } from "lucide-react";

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const { refresh } = useAuth();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/admin-login", { username, password });
      await refresh();
      toast.success("Welcome, admin");
      nav("/admin");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#09090B] text-zinc-100 flex items-center justify-center p-5">
      <div className="w-full max-w-md border border-rose-400/20 bg-[#121214] rounded-sm p-6 sm:p-8">
        <div className="flex items-center gap-2 mb-5">
          <LineChart className="w-5 h-5 text-rose-400" strokeWidth={1.5} />
          <div className="font-mono text-sm tracking-widest uppercase">BonBot · Admin</div>
        </div>
        <div className="flex items-center gap-2 mb-1">
          <Shield className="w-4 h-4 text-rose-400" strokeWidth={1.5} />
          <h1 className="text-2xl font-medium tracking-tight">Restricted area</h1>
        </div>
        <p className="text-zinc-500 text-sm mb-7">Operations console for tenant + bot administration.</p>

        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <Field label="Username">
            <input data-testid="admin-username-input" value={username} onChange={(e) => setUsername(e.target.value)}
                   placeholder="Admin" autoComplete="username" required
                   className="w-full bg-black border border-white/10 rounded-sm px-3 py-2 text-sm font-mono focus:border-zinc-500 focus:outline-none" />
          </Field>
          <Field label="Password">
            <input data-testid="admin-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                   autoComplete="current-password" required
                   className="w-full bg-black border border-white/10 rounded-sm px-3 py-2 text-sm font-mono focus:border-zinc-500 focus:outline-none" />
          </Field>
          <button data-testid="admin-login-submit" type="submit" disabled={loading}
                  className="w-full bg-rose-400/10 text-rose-400 border border-rose-400/30 hover:bg-rose-400/20 px-4 py-2.5 text-sm font-mono uppercase tracking-widest rounded-sm disabled:opacity-50">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div>
      <label className="text-[10px] uppercase tracking-widest text-zinc-500 mb-1.5 block">{label}</label>
      {children}
    </div>
  );
}
